import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

// SELL23 — a small counter for backoffice work that is waiting: today the
// pending shipments on the Store nav entry and on the Shipping tab. Renders
// nothing at zero (or for a missing count), so callers can pass the raw value.
const CountBadge = ({ count }) => {
  if (!count) return null;

  return (
    <span className='count-badge'>
      { count > 99 ? '99+' : count }
    </span>
  );
};

CountBadge.propTypes = {
  count: PropTypes.number,
};

export default CountBadge;
